export enum KeywordSelectionEnum {
    SAVED_MENTION = 'SAVED_MENTION',
    MANUAL = 'MANUAL'
}
